import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

/**
 * /payment/cancel — user backed out of Stripe Checkout without paying.
 */
export default function PaymentCancel() {
  return (
    <div
      data-testid="payment-cancel-page"
      className="min-h-screen bg-[color:var(--mano-bg)] flex items-center justify-center px-5 py-10"
    >
      <div className="max-w-md w-full rounded-3xl bg-white border border-[color:var(--mano-border)] p-8 text-center space-y-5">
        <div className="mx-auto h-16 w-16 rounded-full bg-slate-100 flex items-center justify-center">
          <XCircle size={36} className="text-slate-500" />
        </div>
        <div className="font-display text-2xl">Checkout cancelled</div>
        <p className="text-sm text-[color:var(--mano-ink-soft)]">
          No charge was made. Whenever you're ready, you can restart the
          checkout from the Therapies page.
        </p>
        <Link
          to="/therapies"
          data-testid="payment-cancel-back"
          className="inline-flex items-center justify-center gap-2 h-11 rounded-full bg-[color:var(--mano-primary)] text-white font-semibold px-6"
        >
          <ArrowLeft size={14} /> Back to Therapies
        </Link>
      </div>
    </div>
  );
}
